/*-------------------- beard-collection-new-list----------------------*/

class BeardCollSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.beard-collection-js');
    sliders?.forEach(element => {
      let noOfProducts = qs(".no-of-products",element).value;
      let BeardCollSliderSectionId = element.dataset.id;
      let BeardCollSliderSlide = element.dataset.slide;
      let BeardCollSliderClass = `.beard-collection-js.${BeardCollSliderSectionId}`;
      if(noOfProducts > 3 && screen.width > 767) {
        this.BeardCollSlider(BeardCollSliderClass,BeardCollSliderSlide);
      }
      if(noOfProducts > 2 && screen.width < 768) {
        this.BeardCollSlider(BeardCollSliderClass,BeardCollSliderSlide);
      }
    });
  }
  BeardCollSlider = (sliderClass,BeardCollSliderSlide) => {
    new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      autoHeight:true,
      speed: 1000,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        1: {
          slidesPerView: 2,
          spaceBetween: 10,
          autoHeight:false,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

new BeardCollSlider(qs('.beard-collection-wrapper-js'));